import React from 'react'

import ColumnGridPanel from 'components/ColumnGridPanel'

import ConfigDropdown from 'pages/Device/SystemConfigPanel/ConfigDropdown'
import ShutDownDevices from 'pages/Device/SystemConfigPanel/ShutDownDevices'

import { SystemConfigReport, SystemConfiguration } from 'types/SystemConfigReport'

import { friendlyName, replace } from 'helpers/formatters'

export type Props = Partial<SystemConfigReport> & Pick<SystemConfiguration, 'shutdownDevices'> & {
  deviceType: string
  isEditing: boolean
  onChangeCallback: (arg: Partial<SystemConfiguration>) => void
}

const FILTER_TYPE = { ELECTRONIC_FILTER: 'EAC', COMM_AIR_CLEANER_DISCOVERED: 'COMM EAC' }
const FILTER_LOCATION = ['indoor_unit', 'filter_grill']

const Accessories = (report: Props) => {
  const filterLocationOptions = [...FILTER_LOCATION.map((filterLocation) => [{ value: filterLocation, name: friendlyName(filterLocation) }])]
  const isInstalled = (status) => status === 'INSTALLED'
  const isLinkSystem = report.deviceType === 'control_hub'

  const connections = (name, connections: Array<string> | null | undefined) => {
    return (
      <>
        {(connections || []).map(connection => {
          const connectionName = `${name} (${replace(friendlyName(connection.toLowerCase()), 'link ', '')})`

          return <ColumnGridPanel.Column.Item key={connection} label={connectionName} value="INSTALLED" />
        })}
      </>
    )
  }

  return (
    <ColumnGridPanel.Column>
      <ColumnGridPanel.Column.Header>Accessories</ColumnGridPanel.Column.Header>
      <ColumnGridPanel.Column.Item label="Filtration Type" value={friendlyName(report.filterType, FILTER_TYPE)} />
      <ColumnGridPanel.Column.Item label="Humidifier" value={friendlyName(report.humidifier)} />
      <ColumnGridPanel.Column.Item label="Ventilation" value={friendlyName(report.ventilator)} />
      <ColumnGridPanel.Column.Item label="DeHumidifier" value={friendlyName(report.dehumidification)} />
      {isLinkSystem && isInstalled(report.humidifier) && connections('Humidifier', report.humidifierConnections)}
      {isLinkSystem && isInstalled(report.ventilator) && connections('Ventilation', report.ventilatorConnections)}
      {isLinkSystem && isInstalled(report.dehumidification) && connections('DeHumidifier', report.dehumidifierConnections)}

      <ColumnGridPanel.Column.Item label="Filter Location"
        value={<ConfigDropdown isEditing={report.isEditing} options={filterLocationOptions} value={report.filterLocation} onChangeCallback={(value) => report.onChangeCallback({ filterLocation: value as string })} />}
      />
      <ShutDownDevices {...report} />
    </ColumnGridPanel.Column>
  )
}

export default Accessories
